/**
 * Filter only digits ([0-9]) from a string.
 *
 * @param  {string} value
 * @return {string}
 */
export function filterDigits(value) {
  return value.replace(/\D/g, '');
}

/**
 * Generate a random string with the given length.
 *
 * @param  {number} length
 * @return {string}
 */
export function randomString(length = 25) {
  return [...Array(length)].map((i) => (~~(Math.random() * 36)).toString(36)).join('');
}
